import { openModal } from "../../../../ui/containers/Modal";
import { ButtonComp } from "../../../../ui/input/Button";
import { ComponentF, createElement } from "../../../../ui/ui";
import {
  getXPProgress,
  hasLevelUp,
  isMaxLevel,
} from "../../../actors/xpLevels";
import { gameData } from "../../../GameManager";
import { LevelModal } from "../../level/LevelModal";

export const XPBar: ComponentF<void> = (C, props) => {
  C.display.drawText(
    C.bounds.x,
    C.bounds.y,
    `Level: ${gameData.player.level}`,
    C.bounds.w - 11
  );
  if (isMaxLevel(gameData.player.level)) {
    C.display.drawText(C.bounds.x, C.bounds.y + 1, "XP: Max");
  } else if (!hasLevelUp(gameData.player.level, gameData.xp)) {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y + 1,
      `XP: ${getXPProgress(gameData.player.level, gameData.xp)}`
    );
  } else {
    return [
      createElement(
        ButtonComp,
        { x: 0, y: 1, w: C.bounds.w, h: 1 },
        {
          title: "Lvl Up",
          keys: "x",
          showKey: true,
          onClick: () => {
            if (!gameData.actionPending) {
              openModal(
                createElement(LevelModal, { x: 0, y: 0, w: 48, h: 24 }, {})
              );
            }
          },
        }
      ),
    ];
  }
};
